import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorDetails } from '@modules/common/models/error-details';
import { SnackbarService } from '@modules/common/services/snackbar.service';
import { CopyToClipboardService } from '@modules/common/services/copy-to-clipboard.service';
import * as moment from 'moment';

@Component({
    selector: 'app-error-dialog',
    templateUrl: './error-dialog.component.html',
    styleUrls: ['./error-dialog.component.scss']
})
export class ErrorDialogComponent {
    public errorDetails: string;

    constructor(
        public _dialogRef: MatDialogRef<ErrorDialogComponent>,
        private _snackbarService: SnackbarService,
        private _copyToClipboardService: CopyToClipboardService,
        @Inject(MAT_DIALOG_DATA) error: ErrorDetails
    ) {
        this.errorDetails = this.getFullErrorString(error);
    }

    public close(): void {
        this._dialogRef.close();
    }

    public copyErrorDetails(): void {
        this._copyToClipboardService.copyToClipboard(this.errorDetails);
        this._snackbarService.open({
            message: 'ERROR DETAILS COPIED TO CLIPBOARD'
        });
    }

    private getFullErrorString(error?: ErrorDetails): string {
        if (!error || !error.errorMessage) {
            return '';
        }

        let result = 'ERROR MESSAGE: ' + error.errorMessage + '\r\n\r\n';


        if (error.ipAddress) {
            result += 'IP Address: ' + error.ipAddress + '\r\n';
        }

        if (error.referrer) {
            result += 'Page URL: ' + error.referrer + '\r\n';
        }

        if (error.url) {
            result += 'URL: ' + error.url + '\r\n';
        }

        if (error.username) {
            result += 'Username: ' + error.username + '\r\n';
        }

        if (error.logReferenceId) {
            result += 'Log ID: ' + error.logReferenceId + '\r\n';
        }

        result += 'Timestamp: ' + moment().format("dddd, MMMM Do YYYY, h:mm:ss a ZZ") + '\r\n';

        if (error.stackTrace) {
            result += '\r\n\r\nSTACK TRACE:\r\n' + error.stackTrace;
        }


        return result;
    }
}
